module.exports = __webpack_public_path__ + "fonts/themify.e23a7dca.ttf";